module.exports = __webpack_public_path__ + "static/media/University-of-South-Wales.6b478287.png";